<template>
  <div class="availability-main">
    <b-tabs v-model="tabIndex">
      <b-tab title="Disponibilidade">

        <div v-if="!isValid" class="scp-period-form-wrapper">
          <PeriodRentCreateUpdate
              msg="Como deseja Gerar o Período de Consulta?"
              :showBtnSave="false"
              v-model="periodRent"
          />
        </div>

        <div v-else class="scp-period-bar">
          <div class="scp-period-chip">
            <span class="scp-chip-label">Período</span>
            <i class="fa-regular fa-calendar scp-chip-icon"></i>
            <span class="title">{{ periodRent.deliveryDateHour }} – {{ periodRent.devolutionDateHour }}</span>
            <span v-if="periodRent.totalDays" style="color:#9aa3b0;">( {{ periodRent.totalDays }} {{ periodRent.totalDays === 1 ? 'Dia' : 'Dias' }} )</span>
          </div>
          <button class="scp-edit-btn" @click="editPeriod">
            <i class="fa-regular fa-pen-to-square"></i> Editar
          </button>
        </div>

        <div v-if="isValid && editingPeriod" class="scp-period-form-wrapper scp-period-form-edit">
          <PeriodRentCreateUpdate
              msg="Alterar o Período de Consulta"
              :showBtnSave="false"
              v-model="periodRent"
          />
          <div class="scp-close-edit">
            <Button _key="btnConfirmPeriod" type="info" title="Confirmar" classIcon="fa-solid fa-check-double" size="small" :clicked="confirmPeriod" />
          </div>
        </div>

        <br v-if="isValid && !editingPeriod" />

        <SearchProduct
            v-if="isValid && !editingPeriod && tabIndex == 0"
            :types="'1,2,3,4,5'"
            :status="1"
            :showPrice="hasRule('Rental')"
            :showAddProduct="false"
            :showQuantity="false"
            :canUpdate="false"
            :showAvailability="true"
            :periodRent="periodRent"
        />
      </b-tab>

      <b-tab title="Rastreio de Patrimônio" v-if="hasRule('Stock') || hasRule('Operational')">
        <PatrimonyTracking v-if="tabIndex == 1" @close="closeTimeLineModal"/>
      </b-tab>
    </b-tabs>

    <div
        class="timeline-modal-backdrop"
        v-show="showTimeLineModal"
        @click.self="closeTimeLineModal"
    >
      <div class="timeline-modal-panel">
        <div class="timeline-modal-header">
          <span>Painel</span>
          <button
              type="button"
              class="timeline-modal-close"
              @click="closeTimeLineModal"
          >
            <i class="fa-duotone fa-xmark"></i>
          </button>
        </div>
        <TimeLineAvailability/>
      </div>
    </div>
  </div>
</template>

<script>
import Alert from "@nixweb/nixloc-ui/src/component/layout/Alert";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";

import PeriodRentCreateUpdate from "../../rental/period-rental/PeriodRentCreateUpdate.vue";
import SearchProduct from "../search-product/SearchProduct.vue";
import TimeLineAvailability from "../shared/TimeLineAvailability.vue";
import PatrimonyTracking from "../patrimony/PatrimonyTracking.vue";

import {mapGetters, mapMutations, mapState} from "vuex";

export default {
  name: "StockConsultPanel",
  components: {
    PeriodRentCreateUpdate,
    SearchProduct,
    Alert,
    Button,
    TimeLineAvailability,
    PatrimonyTracking,
  },
  data() {
    return {
      tabIndex: 0,
      editingPeriod: false,
      showTimeLineModal: false,
      periodRent: {
        deliveryDateHour: "",
        startDateHour: "",
        endDateHour: "",
        devolutionDateHour: "",
        description: null,
        minute: 0,
        hour: 0,
        day: 1,
        month: 0,
        year: 0,
        totalDays: 1,
      },
    };
  },
  computed: {
    ...mapState("generic", ["event"]),
    ...mapState("user", ["userLogged"]),
    ...mapGetters("user", ["hasRule"]),
    isUserTemp() {
      return this.userLogged && this.userLogged.user && this.userLogged.user.userName === "UserTemp";
    },
    isValid() {
      return (
          this.periodRent.deliveryDateHour !== "" &&
          this.periodRent.startDateHour !== "" &&
          this.periodRent.endDateHour !== "" &&
          this.periodRent.devolutionDateHour !== ""
      );
    },
  },
  methods: {
    ...mapMutations("generic", ["removeLoading"]),
    editPeriod() {
      this.editingPeriod = true;
    },
    confirmPeriod() {
      this.editingPeriod = false;
      this.removeLoading(["btnConfirmPeriod"]);
    },
    closeTimeLineModal() {
      this.showTimeLineModal = false;
    },
  },
  watch: {
    isValid(val) {
      if (val) this.editingPeriod = false;
    },
    event: {
      handler(event) {
        if (event.name == "timeLineAvailability") {
          this.showTimeLineModal = true;
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.scp-period-form-wrapper {
  max-width: 760px;
  margin: 0 auto;
  padding: 8px 0 4px;
}

.scp-period-form-edit {
  border-radius: 8px;
  padding: 16px;
  margin-top: 8px;
}

.scp-period-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0 4px;
  flex-wrap: wrap;
}

.scp-period-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #e2e5ea;
  border-radius: 20px;
  padding: 5px 14px;
  font-size: 13px;
  color: #374151;
  font-weight: 400;
}

.scp-chip-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: .06em;
  text-transform: uppercase;
  color: #9aa3b0;
}

.scp-chip-icon { font-size: 12px; color: #9aa3b0; }

.scp-edit-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: transparent;
  border: 1px solid #e2e5ea;
  border-radius: 20px;
  padding: 4px 13px;
  font-size: 12px;
  color: #6b7280;
  cursor: pointer;
  transition: background .15s, border-color .15s, color .15s;
}
.scp-edit-btn:hover { background: #f9fafb; border-color: #c4c9d4; color: #374151; }

.scp-close-edit { margin-top: 16px; display: flex; justify-content: center; }

.scp-divider {
  border: 0;
  border-top: 1px solid #e5e4e8;
  margin: 12px 0;
}

.timeline-modal-backdrop {
  position: fixed;
  top: 0; right: 0; bottom: 0; left: 0;
  background-color: rgba(12, 20, 36, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  padding: 16px;
}

.timeline-modal-panel {
  width: 100%;
  max-width: 1000px;
  max-height: 90vh;
  background-color: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 14px;
  overflow: auto;
}

.timeline-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
}

.timeline-modal-close {
  border: none;
  background: transparent;
  font-size: 22px;
  line-height: 1;
  color: #4b5563;
  cursor: pointer;
}

.timeline-modal-hr {
  border: 0;
  border-top: 1px solid #e5e7eb;
  margin-top: 10px;
  margin-bottom: 12px;
}

.availability-main { margin-top: -20px; }
</style>